module.exports = __webpack_public_path__ + "static/img/candle.06c88d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diwali/candle.svg
// module id = keuG
// module chunks = 0